// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a39490ac","239":"2ce7c8b4","453":"99d7af47","732":"9a9b7995"}[chunkId] + ".chunk.js";
};